import { infraModules } from '@/configs/infra-modules';
import { useModuleStore } from '@/configs/module-store';

export function isInfraModuleActive(moduleKey) {
  const moduleStore = useModuleStore();
  return moduleStore.isActive(infraModules[moduleKey]);
}
